/*

    This mixin will handle adding a product to the cart
    
    1.  add a new product
    2.  edit an exing product in the cart
    3.  handle any errors that come back from the server

    This mixin in used in conjuction with a PostAddToCartModals.vue commponent.

*/

// src/mixins/addToCart.js

import { mapActions, mapGetters, mapState } from 'vuex';

export default {
	data: function() {
		return {
			addToCartLoading: false,
			skipOverlap: false,
			overlappedActivitiesModal: {
				show: false,
				hideHeader: true,
				data: null,
			},
			takenTimesModal: {
				show: false,
				hideHeader: true,
				data: null,
			},
			modelErrorsModal: {
				show: false,
				hideHeader: true,
				data: null,
			},
		};
	},

	mounted() {
		//this.mixinTest();
		//     console.log ("Mounted",this.overlappedActivitiesModal, this)
	},
	methods: {
		...mapActions(['ajaxAddToCart']),

		overlappedActivitiesModalNo() {
			this.overlappedActivitiesModal.show = false;
		},
		overlappedActivitiesModalYes() {
			this.skipOverlap = true;
			this.addToCart();
		},

		takenTimesModalOk() {
			this.takenTimesModal.show = false;
		},

		modelErrorsModalOk() {
			this.modelErrorsModal.show = false;
		},

		addToCart() {
			this.addToCartLoading = true;
			this.$emit('updateConfirmLeave', true);
			//var backupSojernProductSnapshot = JSON.parse(JSON.stringify(this.sojernProductSnapshot));
			let self = this;
			// returns a promise
			this.ajaxAddToCart(this.modifiedActiveProductDetails).then(
				// eslint-disable-next-line no-unused-vars
				(json) => {
					console.log('[addToCart()]', json);
					setTimeout(() => {
						this.addToCartLoading = false;
					}, 700);
					self.overlappedActivitiesModal.show = false;
					self.skipOverlap = false;
					if (json.ModelErrors) {
						self.modelErrorsModal.show = true;
						self.modelErrorsModal.data = json.ModelErrors;
					}
					//
					else if (json.TakenTimes) {
						self.takenTimesModal.data = json.TakenTimes;
						self.takenTimesModal.show = true;
					}
					//
					else if (json.OverlappedActivities) {
						//           console.log("Overlapped Activity", json.OverlappedActivities, self.overlappedActivitiesModal, self)
						self.overlappedActivitiesModal.show = true;
						self.$store.commit(
							'updateOverlappedActivities',
							json.OverlappedActivities
						);
						self.overlappedActivitiesModal.data = json.OverlappedActivities;
					}
					//
					else if (json.ExceptionMessage) {
						// alert(
						//   "Something went wrong on the server.  See console for more error information."
						// );
						console.error(json.ExceptionMessage);
					}
					//
					else {
						if (typeof window.OnAddToCart != 'undefined') {
							//console.log("window.OnAddToCart()");
							window.OnAddToCart(
								this.$store.getters.simpleOrder,
								this.modifiedActiveProductDetails
							);
						}

						//this.$store.commit("updateOrder", json.Order);

						// add all to the sojern cart
						// if user completes purchase, they will be added to the conversion list later
						//this.sojernAddProductsToCart(backupSojernProductSnapshot);
						// I think this should just add the one that was just added to the cart?
						//alert('TODO: addSojernCartPixelId. Must use a snapshot. completely ignore the consept of a package.  Iterate over each Activities[]');

						// this.addSojernCartPixelId({
						//     departureDate: product.departureDate,
						//     returnDate: product.returnDate,
						//     name: product.name,
						//     totalParticipants: product.quantity
						// });

						// in order to refresh the form data when a product detail page is accessed the second time
						setTimeout(() => {
							this.$store.commit('revertClient', {});
							// this.$store.dispatch("ajaxClient", {
							//   getOrderNext: false,
							//   force: true,
							//   client: this.$store.state.client.ClientLocationKey
							// });

							// reset activeProduct
							// TODO: this will break the needed product info for sojern
							// delay this so the background image stays around for
							if (window.hj) {
								// eslint-disable-next-line
								window.hj('identify', null, { orderKey: this.order.OrderKey });
							}
							this.$store.commit('updateActiveProductIds', {
								id: null,
								productType: null,
							});

							// console.log("pushing "+ "/" +
							//           this.$route.params.client +
							//           "/cart/" +
							//           this.order.OrderKey)
							this.$router.push({
								path:
									'/' +
									this.$route.params.client +
									'/cart/' +
									this.order.OrderKey,
							});
						}, 500);
					}
				},
				(err) => {
					this.addToCartLoading = false;
					this.$emit('updateConfirmLeave', false);
					console.error(err);
					//   "Got nothing from server. Prompt user to check internet connection and try again"
					// );
				}
			);
		},
	},
	computed: {
		...mapState(['order']),

		...mapGetters(['activeProductDetails', 'clientAgentKey']),

		modifyMixin() {
			return this.$route.params.modify == 'modify' ? true : false;
		},

		isLargeGroupMixin() {
			return this.activeProductDetails.IsLargeGroup;
		},

		// showAddToCartFooter() {
		//   if (this.isLargeGroupMixin || this.modifyMixin) {
		//     return true;
		//   }
		//   return false;
		// },

		modifiedActiveProductDetails() {
			// make a unique copy
			var copy = JSON.parse(JSON.stringify(this.activeProductDetails));

			var orderKey = this.order.OrderKey ? this.order.OrderKey : null;

			copy.OrderKey = orderKey;

			copy.Activities.forEach((act) => {
				act.OrderKey = orderKey;
				act.AppointmentDate = this.$moment(act.AppointmentDate).format(
					'YYYY-MM-DD'
				);
			});

			//alert(this.$route.params.clientAgentKey);
			copy.ClientAgentKey = this.clientAgentKey;

			// copy.ClientAgentKey =
			// 	this.$route.params.clientAgentKey == 'n'
			// 		? null
			// 		: this.$route.params.clientAgentKey;

			copy.SkipOverlap = this.skipOverlap;

			return copy;
		},
	},
};
